import _ from "lodash";
import moment from "moment";
import { BaseAvailability } from "@interfaces";

/**
 * Format booking dates by product class, grouping consecutive days into ranges.
 */
export const formatBookingDatesByProductType = (
    availability: BaseAvailability[],
    productClass: string,
): string => {
    if (!availability?.length) return "";

    const dates = _.chain(availability)
        .map((b) => moment(b.BookingDate, "DD-MMM-YYYY"))
        .sortBy((m) => m.valueOf())
        .uniqBy((m) => m.valueOf())
        .value();

    const buildRanges = (sorted: moment.Moment[]): string[] => {
        const ranges: string[] = [];
        let start = sorted[0];
        let prev = sorted[0];

        for (let i = 1; i < sorted.length; i++) {
            const curr = sorted[i];
            if (curr.diff(prev, "days") !== 1) {
                const endPlusOne = prev.clone().add(1, "day");
                ranges.push(`${start.format("MMM D")} - ${endPlusOne.format("MMM D")}`);
                start = curr;
            }
            prev = curr;
        }
        ranges.push(`${start.format("MMM D")} - ${prev.clone().add(1, "day").format("MMM D")}`);
        return ranges;
    };

    if (productClass === "Y") {
        const formatted = dates.map((d) => d.format("MMM D"));
        if (formatted.length === 1) return `Starts on ${formatted[0]}`;
        if (formatted.length === 2) return `Starts on ${formatted[0]} and ${formatted[1]}`;
        return `Starts on ${formatted.slice(0, -1).join(", ")}, & ${formatted.slice(-1)}`;
    }

    if (productClass === "V") {
        const formatted = dates.map((d) => d.format("MMM D")).join(", ");
        return `Starts on ${formatted}`;
    }

    if (productClass === "A") {
        const ranges = buildRanges(dates);
        return ranges.join(", ");
    }

    return "";
};
